import cx from 'classnames'
import * as React from 'react'

import { search } from '../../icons'
import type { SearchBarViewModel } from '../../view-models/SearchBarViewModel'
import type { ServiceMenuViewModel } from '../../view-models/ServiceMenuViewModel'
import BaseButton from '../BaseButton/BaseButton'
import BaseModal from '../BaseModal/BaseModal'
import Icon from '../Icon/Icon'
import SearchBar from '../SearchBar/SearchBar'
import styles from './serviceMenuMobile-style.css'
import Link from '@/components/Link/Link'

type Props = {
  serviceMenu: ServiceMenuViewModel
  searchBtn?: SearchBarViewModel
  isOpen?: boolean
  onSubmit?: (...args: Array<any>) => any
  onScopeClick?: (...args: Array<any>) => any
}

type State = {
  isSearchOpen: boolean,
  activeScope?: string,
}

class ServiceMenuMobile extends React.Component<Props, State> {
  static displayName = 'ServiceMenuMobile'
  static defaultProps = {}
  state = {
    isSearchOpen: false,
    activeScope: this.props.serviceMenu.links?.[0]?.scope?.title || 'no-scope', // Default to the first scope
  }
  handleSearchToggle = () => {
    this.setState({
      isSearchOpen: !this.state.isSearchOpen,
    })
  }
  handleScopeClick = (scopeTitle: string, items: Array<any>) => {
    this.setState({ activeScope: scopeTitle })
    if (this.props.onScopeClick) {
      this.props.onScopeClick(items)
    }
  }

  renderScopeLinks() {
    const { serviceMenu, onScopeClick } = this.props
    const { activeScope } = this.state

    if (!serviceMenu.links) return null

    function groupByScope(serviceMenu) {
      const scopeMap = new Map();

      serviceMenu.links.forEach(item => {
        const scopeKey = item.scope?.title || 'no-scope';
        if (!scopeMap.has(scopeKey)) {
          scopeMap.set(scopeKey, {
            scope: item.scope,
            items: []
          });
        }
        scopeMap.get(scopeKey).items.push(item);
      });

      return Array.from(scopeMap.values());
    }

    const scopeLinks = groupByScope(serviceMenu)
    const noScopeItems = serviceMenu.links.filter((item) => !item.scope)

    if (!scopeLinks || scopeLinks.length < 2 ) return null

    return (
      <div className={styles.scopeLinks}>
        {scopeLinks.map((scope) => {
          if (scope && scope.scope) {
            return (
              <Link
                key={scope.title}
                {...scope}
                className={cx(styles.serviceMenuDesktopItem, styles.scope,
                  activeScope === (scope.scope?.title || 'no-scope') && styles.active
                )}
                onClick={(e) => {
                  e.preventDefault()
                  const combinedItems = [...scope.items, ...noScopeItems] // Combine clicked scope items and no-scope items
                  if (onScopeClick) {
                    onScopeClick(combinedItems) // Pass the combined list
                  }
                  this.handleScopeClick(scope.scope?.title || 'no-scope', combinedItems) // Update activeScope
                }}
              >
                {scope.scope.label}
              </Link>
            )
          }
          return null
        })}
      </div>
    )
  }


  render() {
    const { serviceMenu, searchBtn, isOpen, onSubmit } = this.props
    const { isSearchOpen } = this.state
    if (!serviceMenu || !serviceMenu.links) return null

    return (
      <div className={styles.serviceMenuMobile}>
        {this.renderScopeLinks()}
        <div className={styles.menu}>
          {searchBtn && (
            <BaseButton className={styles.searchTrigger} onClick={this.handleSearchToggle}>
              <Icon iconSrc={search} width="18px" height="18px" className={styles.icon} />
              <span>{searchBtn.triggerText}</span>
            </BaseButton>
          )}
          {/* Search bar moved to the top of the SideMenuMobile. ServiceMenu links moved to the bottom.
          {serviceMenu.links.map(this.renderItem)}*/}
        </div>
        {isOpen && (
          <BaseModal isOpen={isSearchOpen}>
            <div className={cx(styles.searchComp, isSearchOpen ? styles.show : styles.hide)}>
              <SearchBar
                searchBtn={searchBtn}
                onSearchToggle={this.handleSearchToggle}
                onSubmit={onSubmit}
              />
            </div>
            <div
              className={cx(styles.searchOverlay, isSearchOpen && styles.show)}
              onClick={this.handleSearchToggle}
            />
          </BaseModal>
        )}
      </div>
    )
  }
}

export default ServiceMenuMobile